export * from './baAmChart.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baAmChart/index.ts